module.exports = __webpack_public_path__ + "media/hawaii_small.087059a6.mp4";